import { cashTag } from './CashTag.css';
import type { TCashtagProps } from './CashTag.types';

export const PostCashTag = (props: TCashtagProps) => {
  const { element, children } = props;
  const { clicktracking_disabled, data } = element.attrs;
  const { stocktwits_symbol_href, text_color } = data || {};

  return (
    <a
      href={stocktwits_symbol_href}
      target="_blank"
      rel="noopener noreferrer nofollow"
      data-skip-tracking={clicktracking_disabled}
      className={cashTag}
    >
      <span style={{ color: text_color }}>{children}</span>
    </a>
  );
};
